const csgSwedishStates = {
  Blekinge: 'Blekinge',
  Dalarna: 'Dalarna',
  Gävleborg: 'Gävleborg',
  Gotland: 'Gotland',
  Halland: 'Halland',
  Jämtland: 'Jämtland',
  Jönköping: 'Jönköping',
  Kalmar: 'Kalmar',
  Kronoberg: 'Kronoberg',
  Norrbotten: 'Norrbotten',
  Örebro: 'Örebro',
  Östergötland: 'Östergötland',
  Skåne: 'Skåne',
  Södermanland: 'Södermanland',
  Stockholm: 'Stockholm',
  Uppsala: 'Uppsala',
  Värmland: 'Värmland',
  Västerbotten: 'Västerbotten',
  Västernorrland: 'Västernorrland',
  Västmanland: 'Västmanland',
  Västra_Götaland: 'Västra Götaland',
};

const swedishStateMap = {
  'Blekinge County': csgSwedishStates.Blekinge,
  'Blekinge län': csgSwedishStates.Blekinge,
  'Dalarna County': csgSwedishStates.Dalarna,
  'Dalarnas län': csgSwedishStates.Dalarna,
  'Gävleborgs län': csgSwedishStates.Gävleborg,
  'Gavleborg County': csgSwedishStates.Gävleborg,
  'Gävleborg County': csgSwedishStates.Gävleborg,
  'Gotland County': csgSwedishStates.Gotland,
  'Gotlands län': csgSwedishStates.Gotland,
  'Halland County': csgSwedishStates.Halland,
  'Hallands län': csgSwedishStates.Halland,
  'Jämtland County': csgSwedishStates.Jämtland,
  'Jämtlands län': csgSwedishStates.Jämtland,
  'Jönköping County': csgSwedishStates.Jönköping,
  'Jönköpings län': csgSwedishStates.Jönköping,
  'Kalmar County': csgSwedishStates.Kalmar,
  'Kalmar län': csgSwedishStates.Kalmar,
  'Kronoberg County': csgSwedishStates.Kronoberg,
  'Kronobergs län': csgSwedishStates.Kronoberg,
  'Norrbotten County': csgSwedishStates.Norrbotten,
  'Norrbottens län': csgSwedishStates.Norrbotten,
  'Örebro County': csgSwedishStates.Örebro,
  'Örebro län': csgSwedishStates.Örebro,
  'Östergötland County': csgSwedishStates.Östergötland,
  'Östergötlands län': csgSwedishStates.Östergötland,
  'Skåne County': csgSwedishStates.Skåne,
  'Skåne län': csgSwedishStates.Skåne,
  'Scania County': csgSwedishStates.Skåne,
  'Södermanland County': csgSwedishStates.Södermanland,
  'Södermanlands län': csgSwedishStates.Södermanland,
  'Stockholm County': csgSwedishStates.Stockholm,
  'Stockholms län': csgSwedishStates.Stockholm,
  'Uppsala County': csgSwedishStates.Uppsala,
  'Uppsala län': csgSwedishStates.Uppsala,
  'Värmland County': csgSwedishStates.Värmland,
  'Värmlands län': csgSwedishStates.Värmland,
  'Västernorrland County': csgSwedishStates.Västernorrland,
  'Västernorrlands län': csgSwedishStates.Västernorrland,
  'Västmanland County': csgSwedishStates.Västmanland,
  'Västmanlands län': csgSwedishStates.Västmanland,
  'Västra Götaland County': csgSwedishStates.Västra_Götaland,
  'Västra Götalands län': csgSwedishStates.Västra_Götaland,
};

export { csgSwedishStates, swedishStateMap };
